<template>
	<div class="work-section">
		<div class="work-section__top-sections-wrap">
			<div class="work-section__section work-section__section--mini">
				<h2 class="work-section__title">DELIVERY SCANNING</h2>
				<div class="work-section__content">
					<ScanBox type="DELIVERY"/>
				</div>
			</div>
			<div class="work-section__section work-section__section--mini">
				<h2 class="work-section__title">ORDER STATUS</h2>
				<div class="work-section__content">
					<StatusBox />
				</div>
			</div>
		</div>
		
		<div class="work-section__section">
			<div class="work-section__title-wrap">
				<h2 class="work-section__title">Packing/Inserts</h2>
			</div>
			<div class="work-section__content">
				<PackingTable />
			</div>
			
			<div style="clear: both"></div>
		</div>
		
		
		<div class="work-section__top-sections-wrap">
			<div class="work-section__section work-section__section--mini">
				<h2 class="work-section__title">BULK DELIVERY SCANNING - USE WITH CAUTION</h2>
				<div class="work-section__content">
					<ScanBulkBox type="DELIVERY_BULK"/>
				</div>
			</div>
			<div class="work-section__section work-section__section--mini">
				<div class="work-section__title-wrap">
					<h2 class="work-section__title">Manifests</h2>
					
				</div>
				<div class="work-section__section-inner">
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'GB' " v-on:click="openRM()">Royal Mail</button>
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'GB' " v-on:click="openRMv4()">Royal Mail v4(RB)</button>
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'AU' " v-on:click="openAusPost()">AusPost</button>
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'AU' " v-on:click="openAusPost_RB()">AusPost (RB)</button>
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'NL' " v-on:click="openDPSummary()">DP</button>
					<button class="btn btn--blue2" v-if="this.$store.getters.site == 'US' " v-on:click="openECSummary()">DHL ECS</button>
				</div>
			</div>
		</div>
		
		
		
		<div class="work-section__section">
			<div class="work-section__title-wrap">
				<h2 class="work-section__title">SENT ORDERS LOGS</h2>
				<button class="btn btn--red work-section__btn">clear ALL</button>
			</div>
			<div class="work-section__section-inner">
				<div class="work-section__content work-section__content--scroll">
					<SentOrdersTable />
					<TransporterTable />
				</div>
			</div>
		</div>

		<div class="work-section__section">
			<div class="work-section__title-wrap">
				<h2 class="work-section__title">STAFF SCANNING PERFORMANCE (ADMIN)</h2>
				<button class="btn btn--red work-section__btn">clear ALL</button>
			</div>
			<div class="work-section__content">
				<ScanPerformance />
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import ScanBox from "../components/workstation/ScanBox.vue";
import ScanBulkBox from "../components/delivery/ScanBulkBox.vue";
import StatusBox from "../components/workstation/StatusBox.vue";
import ScanPerformance from "../components/delivery/ScanPerformance.vue";
import SentOrdersTable from "../components/delivery/SentOrdersTable.vue";
import TransporterTable from "../components/delivery/TransporterTable.vue";
import PackingTable from "../components/delivery/PackingTable.vue";

export default Vue.extend({
	name: "Delivery",
	components: {
		ScanBox,
		ScanBulkBox,
		StatusBox,
		ScanPerformance,
		SentOrdersTable,
		TransporterTable,
		PackingTable
	},
	methods: {
		openRM() {
			if (confirm('Are you sure you want to get the Manifest for RM?')) {
				location.href = 'https://new.colorwayrb.com/backend/report_rm.php';
			}
			
		
		},
		openRMv4() {
			if (confirm('Are you sure you want to get the Manifest for RM (Redbubble)?')) {
				location.href = 'https://new.colorwayrb.com/backend/manifest_rm_rb.php';
			}
			
		
		},
		openAusPost() {
			if (confirm('Are you sure you want to get the Manifest for AusPost?')) {
				location.href = 'https://new.colorwayrb.com/backend/auspost/auspostsummary.php';
			}
			
		
		},
		openAusPost_RB() {
			if (confirm('Are you sure you want to get the Manifest for AusPost (RB)?')) {
				location.href = 'https://new.colorwayrb.com/backend/auspost/auspostsummary_rb.php';
			}
			
		
		},
		openDPSummary() {
			if (confirm('Are you sure you want to get the Manifest for DP?')) {
				location.href = 'https://new.colorwayrb.com/backend/dpapi/dpsummary.php';
			}
			
		
		},
		openECSummary() {
			if (confirm('Are you sure you want to get the Manifest for DHL EC?')) {
				location.href = 'https://new.colorwayrb.com/backend/dhlecs/manifest.php';
			}
			
		
		},
	}
});
</script>

<style lang="scss" scoped>
.work-section {
	padding: 0 20px;

	&__top-sections-wrap {
		display: flex;
	}

	&__section {
		border: $border-color 1px solid;
		border-radius: 5px;
		margin-top: 50px;
		width: 100%;

		&--mini:first-child {
			margin-right: 10px;
			width: 35%;
		}

		&--mini:last-child {
			margin-left: 10px;
			width: 65%;
		}
	}

	&__section-inner {
		overflow-y: scroll;
		margin: 5px 0;
	}

	&__title-wrap {
		position: relative;
	}

	&__title {
		border-bottom: $border-color 1px solid;
		background-color: $color7;
		text-align: center;
		font-weight: 600;
		line-height: 27px;
		font-size: 16px;
		padding: 5px 0;
	}

	&__btn {
		font-weight: 500;
		text-transform: uppercase;
		transform: translateY(-50%);
		border-radius: 5px;
		padding: 4px 15px;
		font-size: 12px;

		position: absolute;
		right: 20px;
		top: 50%;
	}

	&__content {
		padding: 20px 0;

		&--scroll {
			padding-left: 10px;
			height: 500px;
		}
	}
}
</style>